import { PlaceholderValue } from "./PlaceholderValue";
import { getFiniteNumber } from "./utils";

const MetricValue = ({ value }: { value?: number | null }) => {
  const resolvedValue = getFiniteNumber(value);

  if (resolvedValue === undefined) {
    return <PlaceholderValue />;
  }

  return <span className="tabular-nums text-foreground">{resolvedValue}</span>;
};

export { MetricValue };
